import { useEffect } from "react";

export const useInfiniteScroll = (loader, setPage) => {
  useEffect(() => {
    var options = {
      root: null,
      rootMargin: "10px",
      threshold: 1.0,
    };
    const observer = new IntersectionObserver(handleObserver, options);
    if (loader.current) {
      observer.observe(loader.current);
    }
    //eslint-disable-next-line
  }, []);

  const handleObserver = entities => {
    const target = entities[0];
    if (target.isIntersecting) {
      setPage();
    }
  };
};
